
import { Options, Vue } from "vue-class-component"; //基本需要\
import * as echarts from "echarts";
import html2canvas from "html2canvas";
import { ElMessage } from "element-plus";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import {
  dispatchGetPerformancePageListSummary,
  dispatchGetPerformanceSelectOptions,
  dispatchDeepNzmSimpleRetry,
  dispatchDeepPerformancSummaryEdit,
  dispatchDsLoagUpload,
  dispatchPerformanceDsLog,
  dispatchPerformanceDsLogData,
  dispatchDeleteDsLogList,
} from "@/store/performance/actions";

import {
  readGetPerfeformanceDsLog,
  readGetPerfeformanceDsLogData,
} from "@/store/performance/getters";
import { store } from "@/store";

import { readDeviceSpecs } from "@/store/device/getters";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";

import { read } from "xlsx";
import { ref } from "vue";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
export default class TestReport extends Vue {
  public svg_name = "";
  public svgName = "";
  public get svgLogList() {
    return readGetPerfeformanceDsLog(store);
  }
  public svn_loading = false;
  public current_page = 1;
  public record = 500;
  public get svgLogData() {
    let list = [];
    list = readGetPerfeformanceDsLogData(store);
    return list;
  }
  public dialogVisible1 = false;
  public async svgChange() {
    this.svn_loading = true;
    this.record = 500;
    this.current_page = 1;
    await dispatchPerformanceDsLogData(store, {
      project: this.localProject,
      id: this.svgName,
      page: this.current_page,
      size: this.record,
    });

    this.svn_loading = false;
  }
  public async pageChange(type) {
    if (type) {
      this.current_page = 1;
    }
    this.svn_loading = true;
    await dispatchPerformanceDsLogData(store, {
      project: this.localProject,
      id: this.svgName,
      page: this.current_page,
      size: this.record,
    });
    this.svn_loading = false;
  }
  public async mounted() {
    this.svn_loading = true;
    await dispatchPerformanceDsLog(store, {
      project: this.localProject,
    });
    if (this.svgLogList.length > 0) {
      this.svgName = this.svgLogList[0].id;
      await dispatchPerformanceDsLogData(store, {
        project: this.localProject,
        id: this.svgName,
        page: this.current_page,
        size: this.record,
      });
    }
    this.svn_loading = false;
  }
  public localProject = Number(getLocalProject());
  public formData: any = new FormData();
  public async UploadFileTop(param: any, file) {
    this.formData.append("file", param.file);
  }
  public async deleteBtn() {
    this.svn_loading = true;
    let b = (this as any).$message({
      //Message 消息提示
      message: "删除中",
      showClose: true,
      duration: 0,
    });
    await dispatchDeleteDsLogList(store, {
      project: this.localProject,
      id: this.svgName,
    });
    await dispatchPerformanceDsLog(store, {
      project: this.localProject,
    });
    this.svgName = this.svgLogList.length > 0 ? this.svgLogList[0].id : "";
    this.current_page = 1;
    this.record = 500;
    await dispatchPerformanceDsLogData(store, {
      project: this.localProject,
      id: this.svgName ? this.svgName : 0,
      page: this.current_page,
      size: this.record,
    });
    this.svn_loading = false;
    b.close();
    ElMessage.success({
      message: "删除成功",
      showClose: true,
      type: "success",
    });
  }
  public async UploadProblem(btn: string) {
    if (btn === "open") {
      this.dialogVisible1 = true;

      // this.formData = new FormData();
      // (this.$refs["upload"] as any)?.clearFiles();
    }
    if (btn === "no") {
      this.formData = new FormData();

      (this.$refs["uploadTop"] as any)?.clearFiles();
    }
    if (btn === "ok") {
      this.svn_loading = true;
      this.formData.append("project", this.localProject);

      this.formData.append("name", this.svg_name);

      let b = (this as any).$message({
        //Message 消息提示
        message: "上传中",
        showClose: true,
        duration: 0,
      });

      await dispatchDsLoagUpload(store, this.formData);

      b.close();
      ElMessage.success({
        message: "数据上传成功",
        showClose: true,
        type: "success",
      });
      await dispatchPerformanceDsLog(store, {
        project: this.localProject,
      });
      this.svgName = this.svgLogList[0].id;
      this.current_page = 1;
      this.record = 500;
      await dispatchPerformanceDsLogData(store, {
        project: this.localProject,
        id: this.svgName,
        page: this.current_page,
        size: this.record,
      });
      this.formData = new FormData();

      (this.$refs["uploadTop"] as any)?.clearFiles();

      this.dialogVisible1 = false;
      this.svn_loading = false;

      //  this.linechangeData()

      // this.linechangeData()

      // this.formData = new FormData();
      // this.fileList = [];
      // (this.$refs["upload"] as any)?.clearFiles();
    }
    // if (btn === "no") {
    //   this.formData1 = new FormData();
    //   (this.$refs["uploadTop"] as any)?.clearFiles();
    // }
    // if (btn === "ok") {
    //   this.formData1.append("project", this.localProject);
    //   this.formTableData = this.formData1;
    //   this.formData1.append(
    //     "project_name",
    //     this.basic_value
    //       ? this.top_base_list.filter((v) => v.id == this.basic_value)[0]
    //           .project_name
    //       : ""
    //   );

    //   let b = (this as any).$message({
    //     //Message 消息提示
    //     message: "上传中",
    //     showClose: true,
    //     duration: 0,
    //   });

    //   await dispatchUploadPerformanceUpload(store, this.formData1);
    //   this.uploadShow = false;
    //   b.close();
    //   ElMessage.success({
    //     message: "数据上传成功",
    //     showClose: true,
    //     type: "success",
    //   });
    //   this.formData1 = new FormData();

    //   (this.$refs["uploadTop"] as any)?.clearFiles();

    //   this.dialogVisible1 = false;

    //   this.current_page = 1;
    //   this.courseSize = 10;
    //   this.checkedCities = ["默认画质"];

    //   //  this.linechangeData()

    //   // this.linechangeData()

    //   // this.formData = new FormData();
    //   // this.fileList = [];
    //   // (this.$refs["upload"] as any)?.clearFiles();
    // }
  }
  public beforeUploadTop(file: any) {
    let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    let isLt2M = file.size / 1024 / 1024 < 50;
    if (["log"].indexOf(extension) === -1) {
      ElMessage.error({
        message: "只能上传后缀是.log的文件",
        showClose: true,
        type: "error",
      });
      (this.$refs["uploadTop"] as any).clearFiles();
    }

    return extension;
  }
}
